module.exports = __webpack_public_path__ + "static/media/Guatemala.149d727e.jpg";